import { render, staticRenderFns } from "./VFileUploader.vue?vue&type=template&id=7c70c4bc"
import script from "./VFileUploader.vue?vue&type=script&lang=ts"
export * from "./VFileUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports